module.exports = __webpack_public_path__ + "img/logo-reksatech.47d4fc4c.png";